import { TachographDriverStatus } from '../enums';

export interface ITachographData {
    id: number;
    positionId?: string;

    // Driver activity and status
    inMovement?: boolean;
    cardId?: string;
    driverStatus: TachographDriverStatus | null;
    cardStatus?: boolean;

    // Driving status
    cumulativeDrivingTime?: number;
    dailyDrivingTime?: number;
    weeklyDrivingTime?: number;
    currentDailyDrivingTime?: number;
    currentWeeklyDrivingTime?: number;
    remainingDailyDrivingTime?: number;
    remainingCurrentDrivingTime?: number;
    remainingShiftDrivingTime?: number;
    remainingWeeklyDrivingTime?: number;

    // Rest status
    cumulativeBreakTime?: number;
    timeLeftUntilDailyRest?: number;
    timeLeftUntilWeeklyRest?: number;
    nextBreakDuration?: number;
    timeUntilNextBreak?: number;

    // Alerts
    dailyDrivingTimeExceeds?: number;

    // Driver id
    driverCardIdMsb?: string;
    driverCardIdLsb?: string;
    cardIssuingMemberState?: string;

    // Timestamps
    timestamp: string;
    insertedAt?: string;
    driverExternalId?: string;
}
